module.exports = __webpack_public_path__ + "img/favorito.1c0eb56e.svg";